/*
 * File: tooltip.ts
 */

import { BaseComponent } from "@root/components/base-classes";
import { Component, Prop, Ref } from "vue-property-decorator";

@Component
export default class Tooltip extends BaseComponent {
    @Prop({ type: String, default: "div" })
    tag!: string;

    /**
     * 是否掛載到 body (全域模式)
     * true: 掛載到 body，使用 fixed 定位 (解決被切掉的問題)
     * false: 原地渲染，使用 absolute 定位 (跟隨父層 scroll)
     */
    @Prop({ type: Boolean, default: false })
    appendToBody!: boolean;

    @Ref("trigger") readonly triggerRef!: HTMLElement;
    @Ref("bubble") readonly bubbleRef!: HTMLElement;

    isVisible: boolean = false;

    // 座標 (僅在 appendToBody = true 時使用)
    top: number = 0;
    left: number = 0;

    get bubbleStyle() {
        // 如果是原地模式 (Local)，不需要 JS 計算位置，全交給 CSS
        if (!this.appendToBody) {
            return {};
        }

        // 全域模式 (Global)
        return {
            top: `${this.top}px`,
            left: `${this.left}px`,
            position: "fixed", // 強制 fixed
            // 這裡移除 transform 的位移，因為 JS 已經算好精確位置了
            // 只保留上浮動畫
            transform: this.isVisible ? "translateY(0)" : "translateY(4px)",
        };
    }

    mounted() {
        if (this.appendToBody && this.bubbleRef) {
            document.body.appendChild(this.bubbleRef);
        }
    }

    beforeDestroy() {
        if (this.appendToBody && this.bubbleRef && this.bubbleRef.parentNode) {
            this.bubbleRef.parentNode.removeChild(this.bubbleRef);
        }
    }

    onShow() {
        this.isVisible = true;

        if (this.appendToBody) {
            // 【關鍵修正】
            // 先顯示 (v-show=true)，等待 DOM 更新，此時 offsetWidth 才有值
            this.$nextTick(() => {
                this.updatePosition();
            });
        }
    }

    onHide() {
        this.isVisible = false;
    }

    updatePosition() {
        if (!this.triggerRef || !this.bubbleRef) return;

        const triggerRect = this.triggerRef.getBoundingClientRect();
        const bubbleRect = this.bubbleRef.getBoundingClientRect(); // 取得當下實際大小

        // 計算水平置中 (Center Horizontally)
        // Trigger左邊界 + (Trigger一半寬) - (Bubble一半寬)
        this.left = triggerRect.left + triggerRect.width / 2 - bubbleRect.width / 2;

        // 計算垂直位置 (Place on Top)
        // Trigger上邊界 - Bubble高度 - 間距(8px)
        this.top = triggerRect.top - bubbleRect.height - 18;
    }
}
